import {sanitizeWhatsappText} from "./sanitizeWhatsappText";

// Yapıştırılan metnin temizlenmiş halini döner, temizliğe gerek yoksa null döner.
// null dönerse tarayıcının kendi yapıştırma davranışı korunur (native undo bozulmasın).
export const sanitizeWhatsappPaste = (event, maxLength) => {
    const clipboardText = event.clipboardData ? event.clipboardData.getData("text") : "";
    const sanitized = sanitizeWhatsappText(clipboardText);
    if (!sanitized || sanitized === clipboardText) return null;

    event.preventDefault();
    const input = event.target;
    const {selectionStart, selectionEnd, value} = input;
    const nextValue = `${value.slice(0, selectionStart)}${sanitized}${value.slice(
        selectionEnd
    )}`.slice(0, maxLength);
    const caretPosition = Math.min(selectionStart + sanitized.length, nextValue.length);

    // setFieldsValue imleci metnin sonuna atıyor, React değeri bastıktan sonra geri alıyoruz
    window.requestAnimationFrame(() => input.setSelectionRange(caretPosition, caretPosition));

    return nextValue;
};
